import ChipRow from "./chip-row";

// Shares the `.mood` slide-up sheet styling; Mood was just its first user.
export default function HelpSheet({
  open,
  isProFeaturesLocked,
  preservePitchMode = false,
  onPreservePitchModeChange,
  speedUpMode = false,
  onSpeedUpModeChange,
  onChangelogClick,
  onUpgradeClick,
  onShortcutsClick,
  // Safari has no page to set an extension's shortcuts on.
  canCustomizeShortcuts = true,
}) {
  const locked = !!isProFeaturesLocked;

  const items = [
    {
      key: "pitch-lock",
      label: "Pitch Lock",
      title: locked
        ? "Pitch Lock is a Pro feature"
        : preservePitchMode
          ? "Keep the original pitch when slowing"
          : "Drop the pitch with the speed",
      // Never reads as on while locked, even if it was left on before.
      selected: !locked && !!preservePitchMode,
      locked,
      onClick: () =>
        locked
          ? onUpgradeClick?.()
          : onPreservePitchModeChange?.(!preservePitchMode),
    },
    {
      key: "speed-up",
      label: "Fast Control",
      title: locked
        ? "Fast Control is a Pro feature"
        : speedUpMode
          ? "Slow Control is speeding the video up"
          : "Turn Slow Control into a fast control",
      // Never reads as on while locked, even if it was left on before.
      selected: !locked && !!speedUpMode,
      locked,
      onClick: () =>
        locked ? onUpgradeClick?.() : onSpeedUpModeChange?.(!speedUpMode),
    },
    // Hidden while locked, as it was in the bottom bar: most commands toggle
    // Pro effects. An action, not a toggle, so it never reads as pressed.
    ...(locked || !canCustomizeShortcuts
      ? []
      : [
          {
            key: "shortcuts",
            label: "Shortcuts",
            title: "Set keyboard shortcuts for Slowed",
            action: true,
            onClick: () => onShortcutsClick?.(),
          },
        ]),
  ];

  return (
    <div
      id="mood-sheet"
      className={`mood mood--help${open ? " mood--open" : ""}`}
      aria-label="Advanced"
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="mood__title-row">
          <div className="content__title">Advanced</div>
          <button
            type="button"
            className="mood__version"
            onClick={() => onChangelogClick?.()}
            title="See what is new in this version"
            tabIndex={open ? 0 : -1}
          >
            {`v${process.env.VERSION}`}
          </button>
        </div>
        <p className="mood__subtitle">Pitch lock, speed direction and shortcuts.</p>
      </div>

      <ChipRow>
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`mood__chip${item.selected ? " mood__chip--selected" : ""}${
              item.locked ? " mood__chip--locked" : ""
            }`}
            onClick={() => item.onClick?.()}
            title={item.title || item.label}
            aria-disabled={item.locked || undefined}
            aria-pressed={item.action ? undefined : !!item.selected}
            tabIndex={open ? 0 : -1}
          >
            <span className="mood__chip-name">{item.label}</span>
          </button>
        ))}
      </ChipRow>
    </div>
  );
}
